<!--
 * @Description: 教学日志检查 详情
 * @Author: ZSC
 * @Date: 2023-04-19 13:30:05.638
 * @LastEditors: PF
 * @LastEditTime: 2024-08-02 12:01:13
-->
<template>
  <div>
    <el-dialog class="wp85 hp85" :model-value="openJianChaDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openJianChaDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pt0 pr0 pb0">
        <el-container>
          <el-header>
            <el-tabs v-model="activeName" @tab-change="bindTable()">
              <el-tab-pane label="教学日志" name="jiaoxuerizhi"></el-tab-pane>
              <el-tab-pane label="作业批改" name="zuoyepigai"></el-tab-pane>
              <el-tab-pane label="教学设计" name="jiaoxuesheji"></el-tab-pane>
              <el-tab-pane label="课件" name="kejian"></el-tab-pane>
              <el-tab-pane label="备课" name="beike"></el-tab-pane>
            </el-tabs>
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <el-table-column label="序号" type="index" width="60" fixed align="center" />
              <el-table-column label="课程名称" prop="kcmc" align="center" sortable :sort-orders="['ascending', 'descending']" show-overflow-tooltip />
              <el-table-column label="班级名称" prop="bjmc" v-if="activeName == 'zuoyepigai'" align="center" sortable :sort-orders="['ascending', 'descending']" show-overflow-tooltip />
              <el-table-column label="评定" prop="pf" align="center" sortable :sort-orders="['ascending', 'descending']" show-overflow-tooltip></el-table-column>
              <el-table-column label="等级" prop="dj" align="center" sortable :sort-orders="['ascending', 'descending']" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="(item, index) in pdgjData" :key="index">
                    <span v-if="scope.row.dj == item.value">{{ item.name }}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="评价人姓名" prop="pjrxm" align="center" show-overflow-tooltip />
              <el-table-column label="评价时间" prop="pjsj" align="center" show-overflow-tooltip />
              <el-table-column label="综合评价" prop="zhpj" align="center" show-overflow-tooltip />
              <el-table-column label="操作" width="225" fixed="right" align="center">
                <template #default="scope">
                  <div v-if="activeName == 'jiaoxuerizhi'">
                    <el-button link type="success" @click="openRiZhiDetail = true; row = scope.row">教学日志详情</el-button>
                    <el-button link type="success" v-if="scope.row.sfypj==true" @click="openRiZhiPingDingDetail = true; row = scope.row">评定详情</el-button>
                    <el-button link type="primary" v-if="scope.row.sfypj==false && scope.row.lx==true" @click="openRiZhi = true; row = scope.row">评定</el-button>
                  </div>
                  <div v-if="activeName == 'zuoyepigai'">
                    <el-button link type="success" @click="openZuoYeDetail = true; row = { id: scope.row.bjzyid,title:scope.row.bjmc }">批改作业详情</el-button>
                    <el-button link type="success" v-if="scope.row.sfypj==true" @click="openZuoYePingDingDetail = true; row = scope.row">评定详情</el-button>
                    <el-button link type="primary" v-if="scope.row.sfypj==false && scope.row.lx==true" @click="openZuoYe = true; row = scope.row">评定</el-button>
                  </div>
                  <div v-if="activeName == 'jiaoxuesheji'">
                    <el-button link type="success" @click="openSheJiDetail = true; row = { id: scope.row.jxsjid }">教学设计详情</el-button>
                    <el-button link type="success" v-if="scope.row.sfypj==true" @click="openSheJiPingDingDetail = true; row = scope.row">评定详情</el-button>
                    <el-button link type="primary" v-if="scope.row.sfypj==false && scope.row.lx==true" @click="openSheJi = true; row = scope.row">评定</el-button>
                  </div>
                  <div v-if="activeName == 'kejian'">
                    <el-button link type="success" @click="openKeJianDetail = true; row = { kjid: scope.row.jxkjid }">课件详情</el-button>
                    <el-button link type="success" v-if="scope.row.sfypj==true" @click="openKeJianPingDingDetail = true; row = scope.row">评定详情</el-button>
                    <el-button link type="primary" v-if="scope.row.sfypj==false && scope.row.lx==true" @click="openKeJian = true; row = scope.row">评定</el-button>
                  </div>
                  <div v-if="activeName == 'beike'">
                    <el-button link type="success" @click="openBeiKeDetail = true; row = { id: scope.row.jxbkid }">备课详情</el-button>
                    <el-button link type="success" v-if="scope.row.sfypj==true" @click="openBeiKePingDingDetail = true; row = scope.row">评定详情</el-button>
                    <el-button link type="primary" v-if="scope.row.sfypj==false && scope.row.lx==true" @click="openBeiKe = true; row = scope.row">评定</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <rizhidetail v-if="openRiZhiDetail" v-model:openDetail="openRiZhiDetail" :row="row" />
  <rizhipingdingdetail v-if="openRiZhiPingDingDetail" v-model:openDetail="openRiZhiPingDingDetail" :row="row" />
  <rizhipingding v-if="openRiZhi" v-model:openPingDing="openRiZhi" :row="row" @ReturnData="bindTable()" />

  <zuoyedetail v-if="openZuoYeDetail" v-model:openDetail="openZuoYeDetail" :row="row" />
  <zuoyepingdingdetail v-if="openZuoYePingDingDetail" v-model:openDetail="openZuoYePingDingDetail" :row="row" />
  <zuoyepingding v-if="openZuoYe" v-model:openPingDing="openZuoYe" :row="row" @ReturnData="bindTable()" />

  <shejidetail v-if="openSheJiDetail" v-model:openDetail="openSheJiDetail" :row="row" />
  <shejipingdingdetail v-if="openSheJiPingDingDetail" v-model:openDetail="openSheJiPingDingDetail" :row="row" />
  <shejipingding v-if="openSheJi" v-model:openPingDing="openSheJi" :row="row" @ReturnData="bindTable()" />

  <kejiandetail v-if="openKeJianDetail" v-model:openDetail="openKeJianDetail" :row="row" />
  <kejianpingdingdetail v-if="openKeJianPingDingDetail" v-model:openDetail="openKeJianPingDingDetail" :row="row" />
  <kejianpingding v-if="openKeJian" v-model:openPingDing="openKeJian" :row="row" @ReturnData="bindTable()" />

  <beikedetail v-if="openBeiKeDetail" v-model:openDetail="openBeiKeDetail" :row="row" />
  <beikepingdingdetail v-if="openBeiKePingDingDetail" v-model:openDetail="openBeiKePingDingDetail" :row="row" />
  <beikepingding v-if="openBeiKe" v-model:openPingDing="openBeiKe" :row="row" @ReturnData="bindTable()" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import {
  closeWindow,
  loadList,
  loadSelect
} from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import pagination from '@/components/pagination.vue'

import rizhidetail from '@/components/home/changguishiwu/jiaoshi/jiaoxuesheji/detailjiaoxuerizhi.vue'
import rizhipingdingdetail from './rizhipingdingdetail.vue'
import rizhipingding from './rizhipingding.vue'

import zuoyedetail from './zuoyedetail.vue'
import zuoyepingdingdetail from './zuoyepingdingdetail'
import zuoyepingding from './zuoyepingding.vue'

import shejidetail from '@/components/home/changguishiwu/jiaoshi/jiaoxuesheji/detailjiaoxuesheji.vue'
import shejipingdingdetail from './shejipingdingdetail.vue'
import shejipingding from './shejipingding.vue'

import kejiandetail from '@/components/home/changguishiwu/jiaoshi/jiaoxuesheji/detailkejian.vue'
import kejianpingdingdetail from './kejianpingdingdetail.vue'
import kejianpingding from './kejianpingding.vue'

import beikedetail from '@/components/home/changguishiwu/jiaoshi/jiaoxuesheji/detailbeike.vue'
import beikepingdingdetail from './beikepingdingdetail.vue'
import beikepingding from './beikepingding.vue'

const props = defineProps({
  openJianChaDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openJianChaDetail', 'ReturnData'])
const activeName = ref('jiaoxuerizhi')
//  弹窗
const row = ref()
const openRiZhiDetail = ref(false)
const openRiZhiPingDingDetail = ref(false)
const openRiZhi = ref(false)
const openZuoYeDetail = ref(false)
const openZuoYePingDingDetail = ref(false)
const openZuoYe = ref(false)
const openSheJiDetail = ref(false)
const openSheJiPingDingDetail = ref(false)
const openSheJi = ref(false)
const openKeJianDetail = ref(false)
const openKeJianPingDingDetail = ref(false)
const openKeJian = ref(false)
const openBeiKeDetail = ref(false)
const openBeiKePingDingDetail = ref(false)
const openBeiKe = ref(false)

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'pjsj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.jxgzjcid = props.row.jxgzjcid
  let url = ''
  switch (activeName.value) {
    case 'jiaoxuerizhi': // 教学日志
      url = '/api/v2/jiaowu/jiaoxuegongzuojiaoxuerizhijiancha/pagelist'
      break
    case 'zuoyepigai': // 作业批改
      url = '/api/v2/jiaowu/jiaoxuegongzuozuoyepigaijiancha/pagelist'
      break
    case 'jiaoxuesheji': // 教学设计
      url = '/api/v2/jiaowu/jiaoxuegongzuojiaoxueshejijiancha/pagelist'
      break
    case 'kejian': // 课件
      url = '/api/v2/jiaowu/jiaoxuegongzuojiaoxuekejianjiancha/pagelist'
      break
    case 'beike': // 备课
      url = '/api/v2/jiaowu/jiaoxuegongzuojiaoxuebeikejiancha/pagelist'
      break
  }
  loadList({
    url: url,
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
      if (res.code === 200) {
        dataGrid.value.data = res.data.list
      } else {
        warningPrompt(res.message)
      }
    }
  })
}

// 评定等级
const pdgjData = ref({})
watch(
  () => props.openJianChaDetail,
  () => {
    if (props.openJianChaDetail) {
      loadSelect({
        url: '/api/v2/jiaowu/jiaoxuegongzuojiancha/pingjiadengji',
        data: pdgjData
      })
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
:deep(.el-table .cell) {
  padding: 0px !important;
}
</style>
